import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'de_LU',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: true,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '64621563-143d-41e9-b05a-a0ab961bed33',
  ''
);
